<template>
  <section class="w-screen h-screen absolute flex justify-center items-center z-50">
    <div id="modal modal-table" class="modal absolute block bg-white dark:bg-dark-800 w-5/6 sm:w-9/12 md:w-5/12 max-w-lg shadow-md rounded-lg dark:shadow-dark-600" :class="{
      'animate__animated animate__zoomIn': showModal,
      'animate__animated animate__zoomOut': !showModal,
    }">
      <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">{{ isEdit ? 'Edit Meja' : 'Tambah Meja' }}</h5>
      </div>
      <div id="modal-body" class="p-5 space-y-4 max-h-[calc(100dvh-220px)] overflow-y-auto">
        <InputTextCustom v-model="name" id="table-name" label="Nomor Meja" placeholder="Masukkan nomor meja"
          input_class="w-full" :valid="validation.name.valid" :error-message="validation.name.message" />
        <InputTextCustom v-model="tableCapacity" id="table-capacity" label="Kapasitas"
          placeholder="Masukkan kapasitas meja" type="number" input_class="w-full" :valid="validation.capacity.valid"
          :error-message="validation.capacity.message" />
        <InputSelect v-model="tableStatus" id="menu-type-select" label="Status" :options="statusOptions"
          placeholder="Pilih menu type" optionLabel="name" optionValue="code" :valid="validation.status.valid"
          :error-message="validation.status.message" />
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600" @click="closeModal" />
          <SubmitButton id="submit" button_name="Submit" button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4"
            @click="submitTable" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import InputTextCustom from '../form/InputTextCustom.vue';
import SubmitButton from '../form/SubmitButton.vue';
import { mapActions } from 'vuex';
import InputSelect from '../form/InputSelect.vue';

export default {
  name: "ModalTable",
  props: {
    table: {
      type: Object,
      default: null,
    }
  },
  components: {
    SubmitButton, InputTextCustom, InputSelect
  },
  data() {
    return {
      showModal: true,
      name: this.table ? this.table.name : '',
      tableCapacity: this.table ? this.table.capacity : 1,
      tableStatus: this.table ? this.table.status : 'available',
      statusOptions: [
        { name: 'Kosong', code: 'available' },
        { name: 'Terisi', code: 'unavailable' }
      ],
      field: ['name', 'capacity', 'status'],
      validation: {
        name: {
          valid: true,
          message: ''
        },
        capacity: {
          valid: true,
          message: ''
        }, status: {
          valid: true,
          message: ''
        },
      },
      isEdit: !!this.table
    }
  },
  watch: {
    table(newVal) {
      if (newVal) {
        this.name = newVal.name;
        this.tableCapacity = newVal.capacity;
        this.tableStatus = newVal.status;
        this.isEdit = true;
      } else {
        this.name = '';
        this.tableCapacity = 1;
        this.tableStatus = 'available';
        this.isEdit = false;
      }
    }
  },
  methods: {
    ...mapActions('tables', ['createTable', 'updateTable']),
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200);
    },
    submitTable() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan meja?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postTable();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan meja', life: 3000 });
        }
      });
    },
    async postTable() {
      try {
        const tableData = {
          name: this.name,
          capacity: parseInt(this.tableCapacity),
          status: this.tableStatus
        };

        if (this.isEdit && this.table) {
          tableData.id = this.table.id;
          await this.updateTable(tableData);
        }
        else {
          await this.createTable(tableData);
        }

        this.closeModal();
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Meja berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save table:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    }
  }
}
</script>
